module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp13_9016.c8e7a0ab.png";